"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderFile = exports.FileGrid = void 0;
const react_1 = __importStar(require("react"));
const react_dropzone_1 = require("react-dropzone");
const fa_1 = require("react-icons/fa");
const bs_1 = require("react-icons/bs");
const Utils_1 = require("../../utils/Utils");
const react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
function MyDropzoneFile({ setFiles, label, maxFile = 1, isPdfFile = false, isMultiFile = false, isVideoFile = false, }) {
    const [maxFileError, setMaxFileError] = (0, react_1.useState)("");
    const onDrop = (0, react_1.useCallback)((acceptedFiles, fileRejections) => {
        if (acceptedFiles) {
            if (maxFile === 1) {
                setFiles(acceptedFiles[0]);
            }
            else {
                setFiles((prevFiles) => {
                    console.log([...prevFiles, ...acceptedFiles]);
                    return [...prevFiles, ...acceptedFiles];
                });
            }
            console.log(acceptedFiles);
        }
        fileRejections.forEach((file) => {
            file.errors.forEach((err) => {
                if (err.code === "too-many-files") {
                    setMaxFileError("Maximum 4 images");
                }
                if (err.code === "file-invalid-type") {
                    setMaxFileError("Types de fichiers non prises en charge");
                }
            });
        });
    }, [maxFile, setFiles]);
    const { getRootProps, getInputProps, fileRejections } = (0, react_dropzone_1.useDropzone)({
        onDrop,
        multiple: isMultiFile,
        maxSize: 209715200,
        accept: isPdfFile
            ? { "application/pdf": [] }
            : {
                "video/mp4": [],
                "video/mpg": [],
                "video/avi": [],
                "video/m4a": [],
            },
    });
    // let acceptedFileItems = acceptedFiles.map((file: FileWithPath) => (
    // 	<div className="col-3" key={file.path}>
    // 		<div className="image-item">
    // 			<img src={URL.createObjectURL(file)} alt={file.path} loading="lazy" />
    // 		</div>
    // 	</div>
    // ));
    const fileRejectionItems = fileRejections.map(({ file, errors }, index) => {
        return (react_1.default.createElement("div", { key: index },
            react_1.default.createElement("ul", { className: "p-0" }, errors.map((e) => (react_1.default.createElement("li", { key: e.code, style: { listStyle: "none" }, className: "text-danger" }, e.code === "file-too-large" &&
                `Le fichier ${index + 1} est trop grand`))))));
    });
    (0, react_1.useEffect)(() => {
        setTimeout(() => setMaxFileError(""), 3000);
    });
    return (react_1.default.createElement("section", { className: "dropzone" },
        react_1.default.createElement("div", Object.assign({}, getRootProps(), { style: {
                border: "1px dashed #9203D7",
                overflow: "hidden",
                opacity: 1,
                borderRadius: "7px",
                display: "flex",
                justifyContent: "center",
                padding: "3rem 15px",
                background: "#F2F6FA",
            } }),
            react_1.default.createElement("input", Object.assign({}, getInputProps(), { type: "file", id: "eglise-files", name: "eglise-files", 
                // accept="application/*"
                accept: isVideoFile
                    ? "video/mp4,video/x-m4v,video/*"
                    : isPdfFile
                        ? "application/pdf"
                        : "application/*" })),
            react_1.default.createElement("div", { className: "start-label-input-choose-file" },
                react_1.default.createElement("div", { className: "flex-c align-items-center mb-3 gap-3" },
                    !!isVideoFile && (react_1.default.createElement(fa_1.FaVideo, { style: { color: "#9203D7", fontSize: "36px" } })),
                    !!isPdfFile && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(fa_1.FaFilePdf, { style: {
                                color: "#9203D7",
                                fontSize: "30px",
                            } })))),
                react_1.default.createElement("span", { className: "first-label-input-choose-file" }, "D\u00E9posez un fichier ici."),
                " ",
                !!isVideoFile && (react_1.default.createElement("span", { className: "second-label-input-choose-file" }, "Format accept\u00E9 : Video, inf\u00E9rieurs \u00E0 200Mo.")),
                !!isPdfFile && (react_1.default.createElement("span", { className: "second-label-input-choose-file" }, "Format accept\u00E9s : PDF, inf\u00E9rieurs \u00E0 200Mo.")))),
        react_1.default.createElement("div", { className: "row pt-4" }, !maxFileError && fileRejectionItems)));
}
exports.default = MyDropzoneFile;
const FileGrid = ({ files, deleteFile }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, files.length
        ? files.map((file, idx) => (
        // <div className="col-md-3 mb-1" key={file.path}>
        //   <div className="image-item">
        //     <img
        //       src={URL.createObjectURL(file)}
        //       alt={file.path}
        //       loading="lazy"
        //       className="img-thumbnail"
        //       id="overlay"
        //     />
        //   </div>
        // </div>
        react_1.default.createElement("div", { className: "col-md-4 col-xl-3", key: idx },
            react_1.default.createElement("div", { className: "product-img-card" },
                react_1.default.createElement("button", { className: "no-style-btn del-product-img", title: "Supprimer", type: "button", onClick: () => {
                        if (deleteFile) {
                            deleteFile(idx, file);
                        }
                    } },
                    react_1.default.createElement(fa_1.FaTrash, null)),
                react_1.default.createElement("img", { src: (file === null || file === void 0 ? void 0 : file.image)
                        ? (0, Utils_1.getImage)(file === null || file === void 0 ? void 0 : file.image)
                        : URL.createObjectURL(file), alt: "product-img", style: {
                        width: "100%",
                        height: "15vw",
                        objectFit: "fill",
                    } })))))
        : ""));
};
exports.FileGrid = FileGrid;
const RenderFile = ({ file, showName = true, }) => {
    var _a;
    const isString = typeof file === "string";
    const isFromServer = isString && file.includes("/mediafiles/");
    const previewUrl = isString
        ? isFromServer
            ? (0, Utils_1.getImage)(file)
            : file
        : URL.createObjectURL(file);
    const fileName = isString
        ? isFromServer
            ? (0, Utils_1.getFileName)(file)
            : "Fichier"
        : file.name;
    const extension = isString ? (_a = file.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase() : "";
    const mimeType = isString
        ? (() => {
            if (!extension)
                return "";
            if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension))
                return "image";
            if (["mp4", "webm", "mov", "avi"].includes(extension))
                return "video";
            if (["mp3", "wav", "ogg"].includes(extension))
                return "audio";
            if (["pdf"].includes(extension))
                return "pdf";
            return "other";
        })()
        : file.type.split("/")[0]; // image, video, audio, etc.
    return (react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center" },
        mimeType === "image" && (react_1.default.createElement(react_medium_image_zoom_1.default, null,
            react_1.default.createElement("img", { src: previewUrl, alt: fileName, style: {
                    width: "50px",
                    height: "50px",
                    borderRadius: "4px",
                    objectFit: "cover",
                } }))),
        mimeType === "video" && (react_1.default.createElement("video", { src: previewUrl, controls: true, style: {
                width: "200px",
                height: "120px",
                borderRadius: "4px",
                objectFit: "cover",
            } })),
        mimeType === "audio" && (react_1.default.createElement("audio", { src: previewUrl, controls: true, style: { width: "150px" } })),
        mimeType === "pdf" && (react_1.default.createElement(bs_1.BsFilePdf, { style: { color: "#296675", fontSize: "28px" } })),
        mimeType === "other" && (react_1.default.createElement("span", { className: "badge bg-secondary" }, "Fichier")),
        showName && (react_1.default.createElement("div", { className: "content-format-statut-table" },
            react_1.default.createElement("p", { className: "name-doc-format mb-1" }, fileName)))));
};
exports.RenderFile = RenderFile;
// export const RenderFile = ({
//   file,
//   isPdfFile = false,
//   isVideoFile = false,
//   isImageFile = false,
// }: {
//   file: any;
//   isPdfFile?: boolean;
//   isVideoFile?: boolean;
//   isImageFile?: boolean;
// }) => {
//   console.log({ file })
//   return (
//     <div className="d-flex gap-2 align-items-center">
//       {!!isPdfFile && (
//         // <img src={PdfImg} alt="pdf" className="pdf-fichier-table" />
//         <BsFilePdf  style={{ color: "#296675", fontSize: "28px" }} />
//       )}
//       {!!isVideoFile && (
//         <MdOutlineOndemandVideo
//           style={{ color: "#296675", fontSize: "28px" }}
//         />
//       )}
//       {!!isImageFile && (
//         <img
//           src={
//             typeof file === "string" && file.includes("/mediafiles/")
//               ? getImage(file)
//               : URL.createObjectURL(file)
//           }
//           alt={file.name || "Uploaded file"}
//           style={{ width: "50px", height: "50px", borderRadius: "4px" }}
//         />
//       )}
//       <div className="content-format-statut-table">
//         <p className="name-doc-format mb-1">{typeof file === "string" && file.includes("/mediafiles/") ? getFileName(file) : file?.name}</p>
//       </div>
//     </div>
//   );
// };
